// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionTitle_sectionTitle__z9x+h","slide":"SectionTitle_slide__Ld3gF","titleText":"SectionTitle_titleText__NidWA","secondary":"SectionTitle_secondary__yyvNl"};